import type { TabStripItem } from "../../components/TabStrip";

/**
 * Look back's compare mode keeps the card to what a comparison is about — the level's overview, its fields
 * and its list — and adds Changes. Everything else (discussion, files, members, settings…) is a job for the
 * live dial, so it waits until compare mode is left rather than crowding the strip beside a second dial.
 */
export const COMPARE_TAB_IDS = new Set<string>(["overview", "about", "info", "sections", "children", "segments", "items", "changes"]);

/** Keeps the compare-mode tabs, in their usual order, and puts Changes last. */
export function withCompareTabs<Id extends string>(items: TabStripItem<Id>[]): TabStripItem<Id>[] {
  return [
    ...items.filter((t) => COMPARE_TAB_IDS.has(t.id)),
    { id: "changes" as Id, label: "Changes", icon: "history" },
  ];
}
